import { Box } from "@mui/system";
import { useState } from "react";

export const HiddenContent = ({ children }) => {
  const [isHidden, setIsHidden] = useState(true);
  return (
    <Box onClick={() => setIsHidden(!isHidden)} sx={{ cursor: "pointer" }}>
      {isHidden ? "---" : children}
    </Box>
  );
};
